/** 托盘相关的流程  */
<script>
import {uploadLogs} from '@/api/user'
export default {
    data(){
        return {
            restoreCount: 0, // 托盘收回次数
            restoreMaxCount: 3 // 最大自动收回次数
        }
    },
    methods: {
        // 检查托盘是否有纸
        checkPaperDishSensor() {
            return new Promise(async (resolve,reject) => {
                let result = await this.ist.call("get_sensor_status");
                console.log("get_sensor_status:" + JSON.stringify(result));
                if(result.result == 0) {
                    let sensor = result.sensor;
                    let paperDishSensor = sensor.sensor1;
                    //检查纸盘是否有纸
                    if(paperDishSensor == 0) { 
                        //有纸
                        console.log('-----有纸')
                        resolve({status:0})
                    } else {
                        // 无纸
                        console.log('-----无纸')
                        resolve({status:1})
                    }
                } else {
                    console.error("获取收票模块传感器发生错误:" + result.message);
                    let message = '获取收票模块传感器未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '获取收票模块传感器'
                    }).catch(e => {})
                    reject({status: -1,message})
                }
            })
        },
        // 弹出托盘
        ejectFile() {
            return new Promise(async (reslove,reject) => {
                let result = await this.ist.call("eject");
                console.log("eject:" + JSON.stringify(result));
                if(result.result == 0) {
                    console.log("退出文件成功");
                    this.$emit('ControlLight', 'eject_light', '500');
                    reslove()
                } else {
                    console.error("退出文件发生错误:" + result.message);
                    let message = '退出文件发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '退出文件'
                    }).catch(e => {})
                    reject({status: -1,message})
                }
            })
            
        },
        restore() {
            return new Promise(async (reslove,reject) => {
                let result = await this.ist.call("restore");
                console.log("restore:" + JSON.stringify(result));
                if(result.result == 0) {
                    console.log("收回托盘成功");
                    this.$emit('ControlLight', 'eject_light', '0')
                    reslove()
                } else if (result.result == -6) { //闸门关闭超时
                    // todo： 处理状态待讨论
                } else if (result.result == -7) { //闸门出口有异物
                    reject({status: -7})
                } else {
                    console.error("收回托盘发生错误:" + result.message);
                    let message = '收回托盘发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '收回托盘'
                    }).catch(e => {})
                    reject({status: -1,message})
                }
            })
            
        },
        // 有异物收回托盘
        resetDish(){
            return new Promise(async(reslove,reject) => {
                let result = await this.ist.resetDevice();
                this.restoreCount++;
                if(result.result == 0) {
                    console.log("关闭闸门成功");
                    this.$emit('ControlLight', 'eject_light', '0')
                    reslove()
                }else if (result.result == -7) {
                    if(this.restoreCount > this.restoreMaxCount) {
                        console.error("收回托盘发生错误已达到最大次数");
                        let message = '收回托盘发生错误已达到最大次数,请联系工作人员处理,错误码:' + JSON.stringify(result)
                        uploadLogs({
                            content: JSON.stringify(result),
                            errorCode:result.result,
                            module: '收回托盘发生错误已达到最大次数'
                        }).catch(e => {})
                        reject({status: 2,message})
                    }else {
                        reject({status: 1})
                    }
                }
            })
            
        }
    }
}
</script>
<style lang="less" scoped>

</style>


